<template>
  <section class="hero is-fullheight cart-page">
    <PmNavbar />
    <asModalDialog ref="passwordUpdated" ok-button-text="Sulje"
      :show-cancel=false>
      <p>
        Salasanasi on vaihdettu, voit nyt kirjautua sisään.
      </p>
    </asModalDialog>
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-4 white-bg p-5">
            <h1 class="mb-4">Vaihda salasanaa</h1>
            <label>Uusi salasana *</label>
            <input
              v-model="form.new_password"
              type="password"
              class="input mb-3"
              placeholder="Uusi salasana *"
            />
            <label>Toista uusi salasana *</label>
            <input
              v-model="form.confirm_password"
              type="password"
              class="input mb-4"
              placeholder="Toista uusi salasana *"
            />

            <div v-if="errors.length" class="notification is-danger mb-4">
              <ul>
                <li v-for="(error, index) in errors" :key="index">
                  {{ error }}
                </li>
              </ul>
            </div>

            <button class="pyroll-button purple-bg font-white" @click="changePassword">
              Nollaa salasanasi
            </button>

          </div>
        </div>
      </div>
    </div>

    <PmFooter />
  </section>
</template>

<script>
import PmNavbar from '../components/PmNavbar'
import PmFooter from '../components/PmFooter'
import {mapActions, mapMutations} from "vuex"
import asModalDialog from "@/helpers/asModalDialog"

export default {
  name: 'RecoverPassword',
  components: {
    PmNavbar,
    PmFooter,
    asModalDialog
  },
  data() {
    return {
      form: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      errors: []
    }
  },
  methods: {
    ...mapActions({
      postUpdateResetPassword: 'postUpdateResetPassword'
    }),
    ...mapMutations({
      setSpinnerState: 'setSpinnerState',
    }),
    changePassword() {
      this.errors = []

      if (!this.form.new_password) {
        this.errors.push('Uusi salasana vaaditaan')
      }

      if (!this.form.confirm_password) {
        this.errors.push('Salasanat eivät täsmää')
      }

      // Password match
      if (this.form.new_password && this.form.new_password !== this.form.confirm_password) {
        this.errors.push('')
      }

      if (this.errors.length) {
        return
      }

      this.setSpinnerState(true)

      this.postUpdateResetPassword(
        {
          'new_password': this.form.new_password,
          'confirm_password': this.form.confirm_password,
          'uid': this.$route.params.uid,
          'token': this.$route.params.token
        }
      ).then(() => {
        this.setSpinnerState(false)
        this.$refs.passwordUpdated.showModal().then(() => {
          this.$router.push({name: 'Landing'})
        })
      })
    }
  },
}
</script>

<style scoped lang="scss">
@use '../assets/sass/variables' as *;
.cart-page {
  .container {
    padding-left: 12px;
    padding-right: 12px;
  }

  .custom-black {
    color: $font-color-primary;
  }

  .white-bg {
    background-color: #ffffff;
  }

  .amount-input {
    width: 66px;
    height: 31px;
    background-color: #DEDBD9;
  }
  .border-bottom {
    border-bottom: 1px solid #707070;
  }
  .visibility-hidden {
    visibility: hidden;
  }

  // Remove arrows in number input type
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  .svg-inline--fa {
    cursor: pointer;
  }

  .mandatory-fields-text {
    color: #DEDBD9;
  }
}

span.is-clickable {
  color: $pyroll-violet;
  svg {
    width: 20px;
    height: 20px;
  }
}

.text-wrapper {
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
